var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 330.24 58.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b3d3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.2,58.88C-2.51,48.52,22.4,33,55.83,24.26s62.75-7.45,65.46,2.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.11,35.52C332.28,25,306.6,10.85,272.75,3.85s-63-4.18-65.22,6.31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset48);
export default __webpack_public_path__ + "static/media/Asset 48.87eb4a6c.svg";
export { ForwardRef as ReactComponent };